import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { News } from '../../models/news.model';
import EpicNewsCard from '../../RifoDesign/EpicNewsCard/epic.news.card.vue';
import EpicNewsPopular from '../../RifoDesign/EpicNewsPopular/epic.news.popular.vue';
import EpicNewsListHeader from '../../RifoDesign/EpicNewsListHeader/epic.news.list.header.vue';
import { NewsListDelegate } from '../../services/DataDelegate/NewsDelegate/news.list.delegate';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import { CommonConfig } from '../../configs/config.common';


@Component({
    components: {
        EpicNewsCard,
        EpicNewsPopular,
        'layout': EpicStandardLayout,
        EpicNewsListHeader,
        EpicHeaderBannerText
    }
})
export default class EpicNewsDetailPage extends Vue {
    public newsDetail: null | News = null;
    public newsListDelegate = new NewsListDelegate();
    public configs = new CommonConfig();
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg5.jpg`;
    public async loadDetail() {
        const result = await this.newsListDelegate.getNewsDetail(this.$route.params.source, this.$route.params.newsid);
         this.newsDetail = {
             id: result.id,
             images: result.images,
             title: result.title,
             detail: result.detail,
             createdat: result.createdat,
             createdatStr: result.createdatStr,
             customized_author_name: result.customized_author_name,
             browseCount: result.browseCount,
             source: this.$route.params.source,
             tags: []
        };
    }
    public async created() {
    }
    @Watch('$route', { immediate: true, deep: true })
    public async onDataInput(val: any, oldVal: any) {
        await this.loadDetail();
    }
}
